import TopNav from "@/pages/home/components/TopNav";
import Hero from "@/pages/home/components/Hero";
import Channels from "@/pages/home/components/Channels";
import ChannelDetail from "@/pages/home/components/ChannelDetail";
import QuerySteps from "@/pages/home/components/QuerySteps";
import ToolCompare from "@/pages/home/components/ToolCompare";
import Safety from "@/pages/home/components/Safety";
import Faq from "@/pages/home/components/Faq";
import RelatedSearch from "@/pages/home/components/RelatedSearch";
import Updates from "@/pages/home/components/Updates";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <TopNav />
      <main>
        <Hero />
        <Channels />
        <ChannelDetail />
        <QuerySteps />
        <ToolCompare />
        <Safety />
        <Faq />
        <RelatedSearch />
        <Updates />
      </main>
      <Footer />
    </div>
  );
}